import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { I18nextProvider } from "react-i18next";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TooltipProvider } from "@radix-ui/react-tooltip";

import App from "@/App";
import { store, persistor } from "@/store";
import { KeycloakProvider } from "@/auth/KeycloakProvider";
import i18n from "@/i18n/config";
import { queryClient } from "@/api/query-client";
import { ToastViewport } from "@/components/ui/Toast";
import { captureSourceChannelOnce } from "@/lib/sessionContext";
import "@/styles/globals.css";

// Telemetria: cattura UTM / document.referrer all'avvio dell'app, PRIMA di
// React (e quindi di StrictMode). I parametri UTM sono validi solo al primo
// landing — qualunque navigation in-app successiva sostituisce la querystring.
// La funzione è idempotente: scrive in sessionStorage solo la prima volta.
captureSourceChannelOnce();

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found in index.html");

createRoot(root).render(
  <StrictMode>
    <KeycloakProvider>
      <ReduxProvider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <TooltipProvider delayDuration={250}>
                <App />
                <ToastViewport />
                {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
              </TooltipProvider>
            </I18nextProvider>
          </QueryClientProvider>
        </PersistGate>
      </ReduxProvider>
    </KeycloakProvider>
  </StrictMode>,
);
